import React, { Component } from "react";
import { connect } from "react-redux";
import { breadcrumbs } from "../../../../../actions/appActions";
import { push } from "react-router-redux";
import { OfficialsPublic } from "../../../components/grids/OfficialGrid";
import { styles } from "../../../index";
import { reduxForm, Field } from "redux-form";
import Input from "../../../../../components/form/Input";
import Button from "../../../../../components/form/Button";
import { publicUrlHelp } from "../../../CroUtils";
import { isEmpty } from "lodash";

import { dataPageNoData } from "../../../../../components/Grid/dataActions";
import { getDecodedUser } from "../../../../../utils/login";

const onSubmit = (auth, data) => (dispatch) => {
  const gridName = `officialsGrid_public_${getDecodedUser().sub || "notLogged"}`;

  dispatch(dataPageNoData(gridName, 0));
  dispatch(
    push({
      pathname: `${publicUrlHelp(auth)}/funkcionari`,
      query: !isEmpty(data.search) ? { q: data.search } : {},
    }),
  );
};
const Form = ({ handleSubmit, onSubmit, submitting }) => (
  <div className="officialSearch">
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="searchForm officialSearch__form"
    >
      <div className="officialSearch__row">
        <div className="officialSearch__field">
          <Field
            id="search"
            className="search"
            name="search"
            component={Input}
            fullWidth
            inputProps={{ 'aria-label': 'Hledat osobu' }}
          />
        </div>
        <div className="officialSearch__actions">
          <Button
            type="submit"
            style={{ ...styles.buttons }}
            label="Hledej"
            disabled={submitting}
          />
        </div>
      </div>

      <Field
        name="dummy"
        component={Input}
        type="hidden"
        style={{ display: "none" }}
      />
    </form>
  </div>
);

const ReduxForm = reduxForm({
  form: "publicForm",
  enableReinitialize: true,
})(Form);

const mapDispatchToProps = (dispatch, { auth }) => ({
  onSubmit: (data) => dispatch(onSubmit(auth, data)),
});
const ConnectedForm = connect(
  (state, { query }) => ({
    initialValues: { search: query.q },
    dummy: "dummy",
  }),
  mapDispatchToProps,
)(ReduxForm);

class PublicOfficials extends Component {
  componentWillMount() {
    this.props.breadcrumbs([{ label: "Centrální registr oznámení" }]);
  }

  componentDidMount() {
    this.focusSearch();
  }

  componentDidUpdate() {
    this.focusSearch();
  }

  focusSearch = () => {
    const element = document.getElementById("search");
    if (element) {
      element.focus();
    }
  };

  onRowClick = ({ id }) => {
    this.props.push(`${publicUrlHelp(this.props.auth)}/funkcionari/form/${id}`);
  };

  render() {
    const { location } = this.props;
    return (
      <div>
        <div>
          <ConnectedForm query={location.query} auth={this.props.auth} />
        </div>
        <OfficialsPublic
          gridName="officialsGrid_public"
          url="/verejnost/api/funkcionari"
          query={location.query}
          onRowClick={this.onRowClick}
        />
      </div>
    );
  }
}

export default connect(null, { breadcrumbs, push })(PublicOfficials);
